import { createFileRoute } from "@tanstack/react-router";
import Formulario from "@/pages/app/Formulario";

export const Route = createFileRoute("/app/formulario/$id")({
  head: () => ({ meta: [{ title: "Formulário | Braussie - Nutri" }] }),
  component: FormularioDaRota,
});

function FormularioDaRota() {
  const { id } = Route.useParams();
  return <Formulario id={id} />;
}
